import React, { useEffect } from 'react';
import get from 'lodash/get';
import {
  useParams,
  Link,
  useHistory,
} from 'react-router-dom';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons/faPencilAlt';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import { resolveTo } from '~/commons/helpers';
import PageHttp from '~/commons/components/PageHttp.jsx';
import Header from '../../layout/Header.jsx';
import { isPermitted } from '../../layout/Nav.jsx';
import FormCollection from '../../forms/FormCollection.jsx';
import ListDesigns from '../../lists/ListDesigns.jsx';

const PageDesign = () => {
  const { _id } = useParams();
  const [res, req] = useHttpStatus();
  const history = useHistory();

  useEffect(() => {
    if (_id !== 'new') {
      req({ url: `/api/core/collections/${_id}` });
    }
  }, [_id]);

  const breadcrumb = _id === 'self' ? [] : [
    { to: '../', children: 'Collections' },
  ];

  return _id === 'new' ? (
    <>
      <Header breadcrumb={breadcrumb}>New Collection</Header>
      <FormCollection />
    </>
  ) : (
    <PageHttp res={res}>
      {(doc) => {
        const info = [
          { label: 'Collection', v: get(doc, 'name') },
          { label: 'Organizations', v: get(doc, 'orgIds', []).join(', ') },
        ].filter((({ v }) => v));

        return (
          <>
            <Header breadcrumb={breadcrumb}>
              {doc.name}
            </Header>
            {/* info */}
            <div className="card p-4">
              <div className="row align-items-center">
                <div className="col">
                  {info.map((a, i) => (
                    <div className="row" key={i}>
                      <div className="col-4">
                        <strong>{a.label}</strong>
                      </div>
                      <div className="col">{a.v}</div>
                    </div>
                  ))}
                </div>
                <div className="col-auto">
                  <Link
                    to={resolveTo('edit')}
                    className="btn btn-link">
                    <FA icon={faPencilAlt} size="lg" />
                  </Link>
                </div>
              </div>
            </div>

            {/* list */}
            {isPermitted('stocks') && (
              <div className="mt-5">
                <ListDesigns
                  filter={{ coll: _id }}
                  actions={{
                    create: false,
                    fileImport: false,
                  }}
                  fileImport={false}
                  onRowClick={(row) => {
                    history.push(
                      `/admin/designs/items/${row._id}`,
                    );
                  }}
                  segment="designs"
                />
              </div>
            )}
          </>
        );
      }}
    </PageHttp>
  );
};

export default PageDesign;
